/// basically a useEffect that does nothing on intial render
import {DependencyList, useEffect, useRef } from 'react';

export function useDidUpdateEffect(fn: () => void, inputs: DependencyList) {
    const didMountRef = useRef(false);

    useEffect(() => {
        if (didMountRef.current) { 
        return fn();
        }
        didMountRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
}